import React from "react";
import CaseGenerator from "../../CaseGenerator/CaseGenerator";
import { CaseForms } from "../../../helpers/enums";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import Modal from "../../common/Modal/Modal";
import { useTranslation } from "react-i18next";

const AssociaContrattoAmministratore = () => {
  const history = useHistory();
  const listContracts = useSelector(
    (state) => state.contracts.contractsSelected
  );
  const { t } = useTranslation();
  return (
    <div data-testid="AssociaContrattoAmministratore">
      {!listContracts || listContracts.length === 0 ? (
        <Modal
          icon={"gc-icon-functional-attention-2-col"}
          show={!listContracts || listContracts.length === 0}
          onClose={() => history.push("/contracts/add")}
          type={"link"}
          to={"/contracts/add"}
          linkTitle={t("cases.associa.contract.admin.error.modal.title")}
          description={t("cases.associa.contract.admin.error.modal.description")}
        />
      ) : (
        <CaseGenerator
          type={CaseForms.AssociaContrattoAmministratore}
          contractsState={listContracts}
        />
      )}
    </div>
  );
};

export default AssociaContrattoAmministratore;
